(function(){
if(window.__hldShip)return;window.__hldShip=1;
var NEED=4, BUSY=0;
var CSS='#hld-ship{display:block;margin:0 0 18px;padding:0 0 16px;border-bottom:1px solid rgba(239,231,215,.12)}'
+'#hld-ship .t{display:block;font-size:.82rem;line-height:1.4;color:rgba(239,231,215,.85);margin:0 0 10px}'
+'#hld-ship .t b{color:#c4a054;font-weight:500}'
+'#hld-ship .bar{display:block;height:2px;background:rgba(239,231,215,.12)}'
+'#hld-ship .bar i{display:block;height:100%;background:#c4a054;transition:width .3s ease}';
function css(){if(document.getElementById('hld-ship-css'))return;var s=document.createElement('style');s.id='hld-ship-css';s.textContent=CSS;(document.head||document.documentElement).appendChild(s)}
function msg(n){
 if(n>=NEED)return '<span class="t">Free shipping <b>unlocked</b></span>';
 var left=NEED-n;
 return '<span class="t">Add <b>'+left+' more '+(left===1?'handle':'handles')+'</b> for free shipping</span>';
}
function render(cart){
 var host=document.querySelector('#shopify-section-cart-drawer-section')||document;
 var anchor=host.querySelector('.cart-totals');
 if(!anchor)return;
 var n=cart&&typeof cart.item_count==='number'?cart.item_count:0;
 if(n<=0){var old0=document.getElementById('hld-ship');if(old0)old0.remove();return}
 var pct=Math.min(100,Math.round(n/NEED*100));
 var el=document.getElementById('hld-ship');
 if(!el){el=document.createElement('div');el.id='hld-ship';anchor.parentNode.insertBefore(el,anchor)}
 el.innerHTML=msg(n)+'<span class="bar"><i style="width:'+pct+'%"></i></span>';
}
function refresh(){
 if(BUSY)return;BUSY=1;
 fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){css();render(c)}).catch(function(){}).then(function(){setTimeout(function(){BUSY=0},250)});
}
var obs=new MutationObserver(function(muts){
 for(var i=0;i<muts.length;i++){var t=muts[i].target;if(t&&t.closest&&t.closest('#hld-ship'))return}
 obs.disconnect();refresh();setTimeout(function(){obs.observe(document.body,{childList:true,subtree:true})},300);
});
function boot(){css();refresh();obs.observe(document.body,{childList:true,subtree:true});
 document.addEventListener('click',function(){setTimeout(refresh,600)},true);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();